import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import "./header.css";
import logo from "./logo.png";

const Header = () => {
  const headerRef = useRef(null);
  const navRef = useRef(null);
  const menuBtnRef = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);
  const [showProgramsMenu, setShowProgramsMenu] = useState(false);

  // Sticky header
  useEffect(() => {
    const onScroll = () => {
      if (!headerRef.current) return;
      const scrolled = window.scrollY > 80;
      headerRef.current.classList.toggle("sticky__header", scrolled);
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const onDocClick = (e) => {
      if (!menuOpen) return;

      const nav = navRef.current;
      const btn = menuBtnRef.current;

      const clickedInsideNav = nav && nav.contains(e.target);
      const clickedMenuBtn = btn && btn.contains(e.target);

      if (!clickedInsideNav && !clickedMenuBtn) {
        setMenuOpen(false);
        setShowProgramsMenu(false);
      }
    };

    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [menuOpen]);

  const closeMenu = () => {
    setMenuOpen(false);
    setShowProgramsMenu(false);
  };

  return (
    <nav ref={headerRef}>
      <div className="navbar">
        {/* Menu Icon */}
        <i
          ref={menuBtnRef}
          className="bx bx-menu"
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => setMenuOpen(true)}
        />

        {/* Logo */}
        <div className="logo">
          <NavLink to="/" onClick={closeMenu}>
            <img src={logo} alt="logo" />
          </NavLink>
        </div>

        {/* Links */}
        <div
          ref={navRef}
          className={`nav-links ${menuOpen ? "open" : ""}`}
        >
          <div className="sidebar-logo">
            <span className="logo-name"></span>
            <i
              className="bx bx-x"
              style={{ marginLeft: "70%", marginTop: "20%", cursor: "pointer" }}
              onClick={closeMenu}
            />
          </div>

          <ul className="links">
            <li>
              <NavLink to="/" onClick={closeMenu}>
                Home
              </NavLink>
            </li>

            {/* Programs (your route is /our-programs) */}
            <li>
              <NavLink to="/our-programs" onClick={closeMenu}>
                Programs
              </NavLink>
            </li>

            <li>
              <NavLink to="/aboutus" onClick={closeMenu}>
                About Us
              </NavLink>
            </li>

            <li>
              <NavLink to="/contact" onClick={closeMenu}>
                Contact Us
              </NavLink>
            </li>

            {/* Optional Blog */}
            <li>
              <NavLink to="/Blog" onClick={closeMenu}>
                Blog
              </NavLink>
            </li>

            {/* Example dropdown (only if you need it)
            <li>
              <button
                type="button"
                className="js-arrow"
                onClick={() => setShowProgramsMenu((v) => !v)}
              >
                More <i className="bx bxs-chevron-down arrow" />
              </button>

              <ul className={`js-sub-menu sub-menu ${showProgramsMenu ? "show" : ""}`}>
                <li><NavLink to="/Male" onClick={closeMenu}>Male</NavLink></li>
                <li><NavLink to="/Female" onClick={closeMenu}>Female</NavLink></li>
              </ul>
            </li>
            */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
